import React from "react";

import {MuiIcon, MuiIconExternalProps} from './MuiIcon';

export const DangerIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue000'}</MuiIcon>
    );
}
